/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

export class AppConstants {
  //public static get MIN_PI(): number { return 0.1; }

  //public static readonly MS_IN_DAY = 1000 * 60 * 60 * 24;       // milliseconds in a day
  //public static dateDiff(startingDate: Date, endingDate?: Date) {
  //  var startDate = new Date(startingDate.toISOString().substr(0, 10));
  //  var endDate = endingDate ? new Date(endingDate.toISOString().substr(0, 10)) : new Date(new Date().toISOString().substr(0, 10));
  //  if (startDate > endDate) {
  //    var swap = startDate;
  //    startDate = endDate;
  //    endDate = swap;
  //  }
  //  var startYear = startDate.getFullYear();
  //  var february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
  //  var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  //  var totalDays = (endDate.getTime() - startDate.getTime()) / AppConstants.MS_IN_DAY;
  //  var yearDiff = endDate.getFullYear() - startYear;
  //  var monthDiff = endDate.getMonth() - startDate.getMonth();
  //  if (monthDiff < 0) {
  //    yearDiff--;
  //    monthDiff += 12;
  //  }
  //  var dayDiff = endDate.getDate() - startDate.getDate();
  //  if (dayDiff < 0) {
  //    if (monthDiff > 0) {
  //      monthDiff--;
  //    } else {
  //      yearDiff--;
  //      monthDiff = 11;
  //    }
  //    dayDiff += daysInMonth[startDate.getMonth()];
  //  }

  //  return { years: yearDiff, months: monthDiff, days: dayDiff, totalDays: totalDays };
  //}

  public static readonly MIN_LABORRATE_USD = 0;
  public static readonly MAX_LABORRATE_USD = 10000;
  public static readonly MIN_HOURS_PER_DAY = 0.1;
  public static readonly MAX_HOURS_PER_DAY = 24;
  public static readonly MIN_DAYS_PER_WEEK = 0.1;
  public static readonly MAX_DAYS_PER_WEEK = 7;
  public static readonly MIN_PI = .1;
  public static readonly MAX_PI = 40;
  public static readonly MIN_MBI = -3.0;
  public static readonly MAX_MBI = 20.0;
  public static readonly MIN_SIZE = 25.0;
  public static readonly MAX_SIZE = 25000000.0;
  public static readonly MAX_GEAR = 999999.0;
  public static readonly MIN_GEAR = 1.0;
  public static readonly MAX_MONETARY_CONVERSION = 200.0;
  public static readonly MIN_MONETARY_CONVERSION = 0.000001;
  public static readonly MIN_MTTD_DAYS = 0.01;
  public static readonly MAX_MTTD_DAYS = 99999;
  public static readonly MIN_COST = 10.0;
  public static readonly MAX_COST = 999999999.0;
  public static readonly MIN_TIME = 0.5;
  public static readonly MAX_TIME = 240.0;
  public static readonly MIN_EFFORT = 80.0;
  public static readonly MAX_EFFORT = 9000000.0;
  public static readonly MIN_EFFORT_CLOSEOUT = 0;
  public static readonly MAX_EFFORT_CLOSEOUT = 9000000;
  public static readonly MIN_STAFF = 0.5;
  public static readonly MAX_STAFF = 2000.0;
  public static readonly MIN_TREND_SIZERANGE = 100.0;
  public static readonly MAX_TREND_SIZERANGE = 2000000.0;
  public static readonly MAX_PHASE3_DURATION = 20;  //in years
  public static get MIN_STARTDATE(): Date { return new Date(1950, 0, 1); }
  public static get MAX_STARTDATE(): Date { let today = new Date(); return new Date(today.getFullYear() + 30, 11, 31); }
  public static readonly MIN_DEFECTS_SIT = 0;
  public static readonly MAX_DEFECTS_SIT = 99999;
  public static readonly MIN_REQUIREMENTS = 0;
  public static readonly MAX_REQUIREMENTS = 1000000;
  public static readonly MIN_DEFECT_TUNE = 1;
  public static readonly MAX_DEFECT_TUNE = 5000;
  public static readonly DAYS_PER_MONTH = 30.4375;
  //public static readonly WEEKS_PER_MONTH = 4.333; }
  public static readonly MIN_WORKHOURS_PER_MONTH = 80;
  public static readonly MAX_WORKHOURS_PER_MONTH = 744;
  public static readonly DEFAULT_WORKHOURS_PER_MONTH = 173;  // 4.333 * 40*/

  public static readonly MAX_PROJECT_NAME_CHAR = 64;
  public static readonly MAX_SOLUTION_NAME_CHAR = 81;
  public static readonly MAX_EXTERNAL_ID_CHAR = 20;     //set in old project page to 20, although 100 in the db
  public static readonly MAX_ORG_NAME_CHAR = 50;
  public static readonly MAX_DIVISION_NAME_CHAR = 50;
  public static readonly MAX_PROJECTS_BEFORE_AGGREGATING = 40;

  public static readonly UNKNOWN_WORKFLOW_STATUS = -1;
  public static readonly DEFAULT_COMPARISON_ID = -1;
  public static readonly NONE_FILTER_ID = -1;
  public static readonly DEFAULT_CURRENTSOL_NAME = "Current Solution";
  public static readonly DEFAULT_BALANCEDSOL_NAME = "Balanced Risk Solution";
  public static readonly DEFAULT_CONTINGENCYSOL_NAME = "Contingency Solution";
  public static readonly BYPASS_UNSAVED_CHANGES_MSG = 'bypassUnsavedChanges';
  public static readonly ERROR_NAVIAGATION_MSG = 'errorNavigation';

  public static readonly MOST_COMMON_TREND_ID = -2;
  public static readonly PROJECT_TREND_ID = -1;
  public static readonly MOST_COMMON_TREND_NAME = "Most Common Trend";
  public static readonly PROJECT_TREND_NAME = "Project Trend";

  public static readonly PROJECT_DASHBOARD_STRATEGY: string = "";
  public static readonly CONTINGENCY_DASHBOARD_STRATEGY: string = "contingency";
  public static readonly PORTFOLIO_DASHBOARD_STRATEGY: string = "portfolio";
  public static readonly RISK_PHRASES: string[] = ["na", "conservative", "moderately conservative", "typical", "moderately risky", "risky"];


  /*public static get TEMPLATEID(): string { return "TemplateId"; }
  public static get IS_TEMPLATE(): string { return "IsTemplate"; }
  public static get CONFIGID(): string { return "ConfigSetId"; }
  public static get CONFIGTYPE(): string { return "ConfigType"; }
  public static get CONFIGNAME(): string { return "ConfigName"; }
  public static get PROJECT(): string { return "Project"; }
  public static get PROJECTNAME(): string { return "ProjectName"; }
  //public static get NEWSOLUTION(): string { return "NewSolution"; }
  public static get SOLUTIONID(): string { return "SolutionId"; }
  public static get SOLUTIONTYPE(): string { return "SolutionType"; }
  //public static get ACCESSMODE(): string { return "AccessMode"; }
  //public static get PROJECTVIEW(): string { return "ProjectView"; }
  public static get OWNER(): string { return "Owner"; }
  public static get USERID(): string { return "UserId"; }
  public static get TRENDGROUPID(): string { return "TrendGroupId"; }*/

  public static readonly WEBAPP_NAME = "qsmweb";
  public static readonly ADMINAPP_NAME = "qsmadmin";
  public static readonly COLLABAPP_NAME = "qsmcollab";
  public static readonly APPLICATION_NAME = "SLIM-Collaborate";

  public static readonly BLANK_PAGE = "about:blank";

  public static readonly FONT_COLOR_PROJECT_NAVIGATION = "#082f4f";

  public static readonly MAX_PI_SIGMARATIO = .10;
  public static readonly MAX_SIZE_SIGMARATIO = .333333;
  public static readonly MAX_LR_SIGMARATIO = .25;

  public static readonly STD_DEBOUNCE_DELAY = 700;
  public static readonly SHORT_DEBOUNCE_DELAY = 200;

  public static readonly COLOR_TRENDBASED_SOLUTION = "#74b576";
  public static readonly COLOR_LOGGED_SOLUTION = "#4d94ff";
  public static readonly COLOR_CURRENT_SOLUTION = "#ffd35b";
  public static readonly COLOR_CONTINGENCY_SOLUTION = "#d0d0d0";
  public static readonly COLOR_BALANCED_RISK_SOLUTION = "#007a6c";
  public static readonly COLOR_ESTIMATION_STAGE = "#ae684a";
  public static readonly COLOR_CLOSEOUT_STAGE = "#4d94ff";
  public static readonly COLOR_BAR_DEFAULT = "green";

  public static readonly NOMINAL_CHART_HEIGHT = 300;    // pixels
  public static readonly ONE_YEAR = 365 * 24 * 60 * 60 * 1000;    // (approroximate) number of microseconds in 1 year

  public static readonly MAX_DASHBOARD_FOLDER_LENGTH = 40;
  public static readonly MAX_DASHBOARD_NAME_LENGTH = 100;

  // **************************************************************
  // Common metric VIDs
  public static readonly VID_NULL = -1;
  public static readonly VID_BASIC_PI = 1;
  public static readonly VID_QUALITY_DEFECTTUNE = 5;
  public static readonly VID_QUALITY_ERRORSSIT = 16;
  public static readonly VID_QUALITY_MTTD = 26;
  public static readonly VID_SLOC_PRODRATE = 321;
  public static readonly VID_FUNIT_PRODRATE = 322;
  public static readonly VID_SLOC_PRODUCTIVITY = 326;
  public static readonly VID_FUNIT_PRODUCTIVITY = 327;
  public static readonly VID_FUNIT_TOTAL = 413;
  public static readonly VID_ACCOUNTING_AVG_LABOR_RATE = 668;
  public static readonly VID_SOLUTION_CONSTRAINT = 908;
  public static readonly VID_FEAS_DURATION_CONSTRAINT = 909;
  public static readonly VID_TREND_BASED_TUNING = 911;
  public static readonly VID_SLOC_TOTAL = 951;
  public static readonly VID_SLOC_EFFECTIVE = 955;
  public static readonly OLDVID_SLOC_EFFECTIVE = 955;
  public static readonly VID_FUNIT_EFFECTIVE = 956;
  public static readonly VID_NEW_PERCENTAGE = 959;
  public static readonly VID_MOD_PERCENTAGE = 960;
  public static readonly VID_REUSED_PERCENTAGE = 961;
  public static readonly VID_P3_COSTNORMAL = 1204;
  public static readonly VID_P3_ENDDATE = 1208;
  public static readonly VID_P3_COST = 1214;
  public static readonly VID_LIFE_EFFORT = 1400;
  public static readonly VID_LIFE_EFFORT_PCT = 1401;
  public static readonly VID_LIFE_TIME = 1402;
  public static readonly VID_LIFE_COST = 1414;
  public static readonly VID_LIFE_COST_PCT = 1415;
  public static readonly VID_LIFE_COSTNORMAL = 1404;
  public static readonly VID_LIFE_PEAK = 1406;
  public static readonly VID_LIFE_AVGSTAFF = 1408;
  public static readonly VID_LIFE_STARTDATE = 1410;
  public static readonly VID_LIFE_ENDDATE = 1412;
  public static readonly VID_TS_STAFF = 1500;
  public static readonly VID_TS_COSTRATE = 1501;
  public static readonly VID_TS_EFFCUM = 1502;
  public static readonly VID_TS_COSTCUM = 1503;
  public static readonly VID_TS_EFFORTRATE = 1504;
  public static readonly VID_TS_SIZECUM = 1511;
  public static readonly VID_TS_SIZERATE = 1514;
  public static readonly VID_TS_DEFECTRATE = 1520;
  public static readonly VID_TS_DEFECTCUM = 1521;
  public static readonly VID_TS_MTTD = 1524;
  // **************************************************************
}
